<template>
  <div>
    <div class="ui form" style="margin-bottom: 30px;">
      <div class="required three fields">
        <div class="field">
          <label for="clinic">Clinic</label>
          <select
            class="ui fluid search dropdown"
            id="clinic-search"
            v-model="selectedClinicId"
            name="clinic"
          >
            <option :value="clinic.id" v-for="clinic in clinics" :key="clinic.id">
              {{ clinic.name }}
            </option>
          </select>
        </div>
        <div class="field">
          <label for="purchasedDate">From Date</label>
          <div style="text-align: center" class="ui calendar" :id="'from-date'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'From Date'"
                     readonly=""
                     name="formDate">
            </div>
          </div>
        </div>
        <div class="field">
          <label for="purchasedDate">To Date</label>
          <div style="text-align: center" class="ui calendar" :id="'to-date'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'To Date'"
                     readonly=""
                     name="toDate">
            </div>
          </div>
        </div>
      </div>
      <div class="ui blue right floated submit button no-print"
           style="background-color: #092442"
           @click="getReportData()">
        Submit
      </div>
    </div>
    
    <br>
    <div class="ui divider"></div>
    <br>
    
    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <div v-else style="padding-bottom: 80px">
      <div class="centered-header">
        <h1>{{ doctorName }} Report</h1>
      </div>
      <br>
      <table
        class="ui center aligned celled very compact table"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th>Id</th>
            <th>Patient Name</th>
            <th>Visit Date</th>
            <th>Profit Type</th>
            <th>Profit</th>
          </tr>
        </thead>
        <tbody v-for="visit in computedDoctorReport" :key="visit.id">
          <tr 
            v-for="(visitCost, index) in visit.visitCosts" 
            :key="index"
          >
            <td v-if="index === 0" :rowspan="visit.visitCosts.length">
              {{ visit.id }}
            </td>
            <td v-if="index === 0" :rowspan="visit.visitCosts.length">
              {{ visit.patientName}}
            </td>
            <td v-if="index === 0" :rowspan="visit.visitCosts.length">
              {{ visit.startedAt }}
            </td>
            <td 
              style="border-left: 1px solid rgba(34,36,38,.1)"
              :class="{negative: visitCost.doctor_profit_as_discount }"
            >
              {{ visitCost.doctor_profit_as_discount ? 'Discount' : 'Profit' }}
            </td>
            <td :class="{negative: visitCost.doctor_profit_as_discount }"> 
              {{ visitCost.doctor_profit }} 
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <th :colspan="4">Total Profit</th>
            <th> {{ formatPrice(getTotalProfit) }} </th>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable')
      .default,
  },
  data() {
    return {
      patientsByReservationId: {},
      reportData: [],
      doctorId: this.$route.params.id,
      from_date: window.moment().startOf('day').toString(),
      to_date: window.moment().endOf('day').toString(),
      selectedClinicId: null,
      loading: true
    };
  },
  mounted() {
    //TODO: fetch data from api
    //TODO: initalize two date picker for the ranging
    let clinicId = this.selectedClinicId || this.getFromLocalStorage('clinicId') || this.clinics[0].id
    this.selectedClinicId = clinicId
    this.initGUI()
    this.getReportData();
  },
  computed: {
    getTotalProfit() {
      const visitCosts = this.reportData
        .flatMap(v => v.visit_details)
        .map(vd => vd.visit_cost)
      return window._.sumBy(visitCosts, visitCost => {
        return !visitCost.doctor_profit_as_discount && Number(visitCost.doctor_profit)
      })
    },
    doctorReportColumns() {
      return [
        { header: 'Visit Id', fieldName: 'id', show: true },
        { header: 'Patient Name', fieldName: 'patient_name', show: true },
        { header: 'Visit Date', fieldName: 'started_at', show: true },
        { header: 'Profit Type', fieldName: 'profit_type', show: true },
        { header: 'Profit', fieldName: 'profit', show: true },
      ];
    },
    computedDoctorReport() {
      let formlatedItems = [];
      window._.each(this.reportData, visit => {
        formlatedItems.push({
          id: visit.id,
          patientName: this.patientsByReservationId[visit.reservation_id].name,
          startedAt: window.moment(visit.started_at).format('DD/MM/YYYY hh:mm a'),
          visitCosts: visit.visit_details.map(vd => vd.visit_cost),
        });
      });

      return formlatedItems;
    },
    doctorName() {
      return this.doctorsMeta.find(this.doctorId).user.name
    }
  },
  methods: {
    getReportData() {
      //TODO: send clinic in params
      this.loading = true
      this.$http.get(`financial/doctor/${this.doctorId}/reports`, {
        params: {
          clinic_id: this.selectedClinicId,
          from_date: this.from_date,
          to_date: this.to_date
        }
      })
      .then(res => {
        this.patientsByReservationId = res.data.meta && res.data.meta.reduce((obj, r) => ({ ...obj, [r.id]: r.patient }), {})
        this.reportData = res.data.visits
        this.initGUI()
        this.loading = false
      })
      .catch(error => console.log(error));
    },
    showData() {
      return JSON.stringify(this.reportData, null, 4);
    },
    initGUI() {
      this.$nextTick(() => {
        $('#clinic-search').dropdown()
        $('#clinic-search').dropdown('set selected', this.selectedClinicId)

        $('#from-date').calendar({
          type: 'date',
          onChange: (date) => {
            this.from_date = date
          }
        })

        $(`#from-date`).calendar(
          'set date',
          this.from_date
        )

        $('#to-date').calendar({
          type: 'date',
          onChange: (date) => {
            this.to_date = date
          }
        })
        
        $(`#to-date`).calendar(
          'set date',
          this.to_date
        )
      })
    }
  }
};
</script>

<style scoped>
.centered-header {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/DoctorFinancialReport.vue